// extracted by mini-css-extract-plugin
export default {"button-wrapper":"n2yp4","buttonWrapper":"n2yp4","dot":"_2Q6t7"};